import React from 'react';
import { motion } from 'framer-motion';

/**
 * TextEffect — per-character blur fade reveal (Motion Primitives style).
 * Chars are wrapped in word-containers so browsers only break at WHITESPACE,
 * never inside a word — preserves Dutch/German hyphenation rules.
 */
export default function TextEffect({
  text,
  className = '',
  delay = 0,
  perCharDelay = 0.02,
  duration = 0.9,
  blur = '12px',
  as: Tag = 'span',
}) {
  const words = String(text).split(' ');
  const MotionTag = motion[Tag] || motion.span;
  let charIndex = 0;
  return (
    <MotionTag className={className} aria-label={text}>
      {words.map((word, wi) => {
        const wordChars = word.split('');
        const wordEl = (
          <span
            key={`w-${wi}-${word}`}
            aria-hidden="true"
            style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
          >
            {wordChars.map((c, ci) => {
              const myIndex = charIndex++;
              return (
                <motion.span
                  key={`c-${wi}-${ci}-${c}`}
                  initial={{ opacity: 0, filter: `blur(${blur})`, y: 12 }}
                  animate={{ opacity: 1, filter: 'blur(0px)', y: 0 }}
                  transition={{
                    duration,
                    delay: delay + myIndex * perCharDelay,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                  style={{ display: 'inline-block' }}
                >
                  {c}
                </motion.span>
              );
            })}
          </span>
        );
        // re-add space after each word (except last), as a separate, breakable text node
        return (
          <React.Fragment key={`frag-${wi}-${word}`}>
            {wordEl}
            {wi < words.length - 1 ? ' ' : null}
          </React.Fragment>
        );
      })}
    </MotionTag>
  );
}
